
import { cn } from '@/lib/utils';

interface HeroSectionProps {
  heroVisible: boolean;
}

const HeroSection = ({ heroVisible }: HeroSectionProps) => {
  return (
    <section className="relative pt-32 pb-20 px-6 bg-gradient-to-br from-primary/20 via-secondary/30 to-accent/20 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 left-10 w-32 h-32 bg-primary/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-40 h-40 bg-secondary/20 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-gradient-to-r from-primary/10 to-accent/10 rounded-full blur-3xl opacity-30"></div>
      </div>
      
      {/* Plus symbols pattern overlay */}
      <div 
        className="absolute inset-0 opacity-15"
        style={{
          backgroundImage: `
            url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%233B82F6' fill-opacity='0.6'%3E%3Cpath d='M20 18v-2h-2v2h-2v2h2v2h2v-2h2v-2h-2z'/%3E%3C/g%3E%3C/svg%3E")
          `,
          backgroundSize: '40px 40px'
        }}
      ></div>
      
      {/* Gradient fade to background at bottom */}
      <div className="absolute inset-x-0 bottom-0 h-24 bg-gradient-to-t from-background via-background/80 to-transparent" />
      
      <div className="max-w-7xl mx-auto text-center relative z-10">
        <h1 
          className={cn(
            "text-4xl md:text-5xl font-bold mb-6 text-foreground transition-all duration-700",
            heroVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          )}
        >
          Our Team
        </h1>
        <p 
          className={cn(
            "text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto transition-all duration-700 delay-200",
            heroVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          )}
        >
          Meet the innovators behind our success, bringing passion and expertise to every project we undertake.
        </p>
      </div>
    </section>
  );
};

export default HeroSection;
